module.exports = __webpack_public_path__ + "img/b_log_idle.0db405ed.png";